// Mirrors Stevie.Cloud.Api.vNext.Models.OutputVideoFormat (ADR 009).
// Backend uses JsonStringEnumConverter, so wire values are the C# member
// names verbatim.
export type OutputVideoFormat = 'Mp4H264' | 'Mp4H265' | 'MovH264' | 'MovH265' | 'WebM' | 'Gif';

export const ALL_OUTPUT_VIDEO_FORMATS: readonly OutputVideoFormat[] = [
  'Mp4H264',
  'Mp4H265',
  'MovH264',
  'MovH265',
  'WebM',
  'Gif',
] as const;
